module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _c('h2', {
    staticClass: "chapterNumber"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/plainclothesnaked_con#ch_03"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("THREE")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_vm._v("Upper Marilyn maintained a five-man police force, if you counted the chief. The town had begun life as an unincorporated area, a hodgepodge batch of neighborhoods plunked due southwest of Pittsburgh. When the mall craze first kicked in, developers realized that owning their own city would mean heftier tax breaks than even the sweetest deal Pittsburgh could cut them. So Upper Marilyn was born. As conceived, the fledgling burg was supposed to come with a sister municipality, Lower Marilyn.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("All of this took place when J.F.K. was in office, in the heyday of Marilyn Monroe, and certain financially involved Methodists thought that “Lower Marilyn” sent the wrong message. No God-fearing soul would put down roots in a place named for an actress’s nether "), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("parts. Why Upper was okay but Lower taboo was a question that engendered decades of obscene and inflammatory lore.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Old-timers dubbed the two regions “Tit-ville” and “Butt-burg.” And, in certain shot-and-Iron City bars, “Meet me at the Bentelbo, up in Tits” or “Uncle Slats got drunk and lost his Buick down in Butt” were still perfectly acceptable locutions.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("An Uppy by birth, Manny now boasted a pad in the heart of Buttburg. As it turned out, the dead foamer’s place squatted no more than three blocks from Manny’s own half-a-rowhouse. He didn’t need the number to locate Chez Marvin. A black-and-white—the town’s only one—had already pulled into the front yard, where its tires left three-foot ruts in the dirt. If five years on the force had taught him nothing else, it was that cops didn’t pull onto the lawns in Upper Marilyn. They didn’t kick down doors, roust teens on the street, or drag drivers out of their cars at random up in Tit-ville, either.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After pulling into the driveway—it never hurt to block a perp’s car, even if somebody’d already cashed his Lotto—Manny slapped and shoved his way through the sight-seers milling around the yard like guests at a summer wedding. About the only officially sanctioned police violence left was the pummeling of “necks,” as the souls who flocked to crime scenes were called. What moved these humans to drop what they were doing so they could loiter within sniffing distance of death was anybody’s guess. Manny wasn’t the kind of cop who needed to blow off steam doing some honest “neck-deckin’.” But he understood guys who did.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Right away, he made a note of the house: a nondescript brown brick on a street of nondescript brown bricks. This stretch of non–Upper Marilyn had seen swankier times. At one point the people who lived here actually had jobs. Some still boasted little lawns, but the deceased’s featured only mud. There was nothing else notable, except for the paramedics at either end of the empty gurney being hauled through the front door. Both, for some strange reason, were giggling.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  })]), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Tina slouched")]), _vm._v(" at the kitchen table, absently tapping the stubby toe of her tennis shoe a few inches from her husband’s white-sheeted head. A pair of “evidence technicians” (plump chemistry profs from Pitt who ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("moonlighted scooping hairs into tiny sandwich bags) knee-walked around Marvin’s body, occasionally “oohing” and “aahing” at a particularly intriguing spray of fiber. They’d already bagged his hands, and spoke in meaningful whispers. Manny had a theory that they dumped the stuff in the nearest Dumpster, and billed the P.D. for lifting the lid.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Tina did not know what to feel. She plucked tissues from a Kleenex Junior box one of the social workers had left, dabbing her eyes and puffing on a Viceroy with the filter ripped off. It was the first thing Manny noticed, that little mountain of cast-off filters in the middle of the table. You could still see the fan pattern where someone had recently sponged the pink Formica.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny liked to arrive on the scene a little late, when whoever he was chatting up was already tired and pissed off from talking and being talked at by half a dozen other nightmares with faces. All detectives had their specialty—reading the scene, turning snitches, following leads. But Manny’s was more basic. He had ears. He knew how to listen, could almost taste things in the way people talked. It wasn’t about what the pacing neighbor or bottle-blond sister-in-law actually said—or not "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("just")]), _vm._v("—but how they picked the lint off their elbows when they said it. How they made sure their eyes drilled into his. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Look at me, I’m honest!")]), _vm._v(") How an accent thickened up or faded in the course of a five-minute chat.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Much of the time, the people he interviewed didn’t believe he was a cop. He was too upset with himself. He kept sighing. He stared at the ceiling a lot. Which unnerved them even more. This was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("their")]), _vm._v(" drama—and here was this unhappy weirdo clearly struggling to forget his own problems long enough to do his job. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“I’m sorry…I had a thing with my wife,”")]), _vm._v(" was one of his standard openers. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“Go ahead, I’m listening….”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("When Tina saw Detective Manny Rubert shuffle in, she threw a balled-up Kleenex on the floor. “Not another one!”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny pulled a chair from the table and sat down like an in-law. “I know, it’s a drag,” he said. “Believe me, I’m not in the mood, either.”")])]), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("He hadn’t expected anyone so pretty, and it threw him. Tina had that Faye Dunaway thing. Faye before the surgery, when her cheekbones were still sharp as can openers and she looked like a feral gazelle. ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("She was that kind of gorgeous. She didn’t look like the wife of a foamer.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("“If you think I’m going to answer another fucking question about anything, you better have a hard ass,” Tina said.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Beg pardon?”")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Manny had no idea what that meant. Rather, he had a couple of ideas: She was going to kick him, or he was going to have sit there until Christmas….")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The meaning didn’t matter. Just the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("weight")]), _vm._v(" of the sentence, the way it came at him like a rock dropped off a freeway overpass. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Airmail,")]), _vm._v(" in happy cop lexicon.) Tina hit that tingle in the back of his head, the fuse that usually stayed damp, the one that got lit on those rare occasions when he met a woman who actually scared him. It was sort of like sex, but harder to find.")])])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page23"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509a6174","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plainclothesnaked_ch03.vue
// module id = 81
// module chunks = 0